import React, { PureComponent } from 'react';
import { Form, Modal, Input, message, Spin, Radio, TreeSelect, Space, Select, Button } from 'antd';
import NewSelectModal from '../../../NewSelectModal/index';
import { getBasicInfo, filterProject } from '../../utils';
import MembersTable from './table';
import { callApi } from 'utils';
import { api, rightGroupModalType } from '../../config';
import  RoleManagement  from '../../components/RoleManagement/index';
import ProjectTree from './ProjectTree';
import './index.less';
import SetRoleBybatch from '../SetRoleBybatch';
const RadioGroup = Radio.Group;
// const { SHOW_PARENT, TreeNode } = TreeSelect;
const { Option } = Select;

const prefixCls = 'right-group-management';
const communityScopeFlag = {
	allCommunitys: 1,
	customCommunitys: 0,
};
const scopeType = {
// 	COMBINATION((byte) 0, “混合型”): COMBINATION
// COMMUNITY((byte) 1, “项目范围型”): COMMUNITY
// ORGANIZATION((byte) 2, “部门范围型”): ORGANIZATION
// CUSTOMIZATION_1((byte) 3, “自定义1型”): CUSTOMIZATION_1
// CUSTOMIZATION_2((byte) 4, “自定义2型”): CUSTOMIZATION_2
	COMMUNITY: 1,
};
const titles = {
	EDIT: '编辑权限组',
	CREAT: '新增权限组',
	DETAIL: '详情'
};
class RightGroupManagement extends PureComponent {
	constructor (props) {
		super(props);
		this.state = {
			allCommunityScopeFlag: communityScopeFlag.allCommunitys,
			projectTree: [],
			// 是否禁用选择’全部项目‘
			allProjectDisabled: false,
			NewSelectModalVisible: false,
			loading: true,
			roleList: [],
			dataGroupId: undefined,
			dataSource: {},
			roleManModal: false,
			checkBoxModal: false,
			targetList: [],
			setRoleDisable: true,

		};
		this.formRef = React.createRef();
		this.tableRef = React.createRef();
		this.roleRef = React.createRef();
	}

	basicInfo = {};

	componentDidMount() {
		this.basicInfo = getBasicInfo();
		this.init();
	}

	init = () => {
		const { id, type } = this.props;
		this.setState({ loading: true }, () => {
			let dependApi = [];
			switch (type) {
				case rightGroupModalType.CREAT:
					dependApi = [
						this.listPrivilegeRole(),
						this.getAuthorizedCommunities()
					];
					break;
				case rightGroupModalType.EDIT:
					dependApi = [
						this.getRoleAuthRuleDetail(id),
						this.getAuthorizedCommunities(),
						this.listPrivilegeRole()
					];
					break;
				default:
					dependApi = [this.getRoleAuthRuleDetail(id)];
			}
			Promise.all(dependApi).catch(() => {
				message.error('获取数据失败');
			}).finally(() => {
				this.setState({
					loading: false
				});
			});
		});
	};

	getRoleAuthRuleDetail = (id) => {
		const { type } = this.props;
		const data = { ...this.basicInfo };
		return callApi({
			api: api.getRoleAuthRuleDetail,
			data: {
			  ...data,
				id
			},
			success: (res = {}) => {
				const { dataScope = {}, members = [], target = {} } = res;
				const	data = {
					allCommunityScopeFlag: dataScope?.allCommunityScopeFlag,
					dataGroupId: target?.targetId,
					dataSource: res,
					setRoleDisable: true
				};
				if (members.length > 0) {
					data.setRoleDisable = false;
				}
				this.setState(data, () => {
					if (type === rightGroupModalType.EDIT) {
						const form = this.formRef.current;
						form.setFieldsValue(
							{
								allCommunityScopeFlag: dataScope?.allCommunityScopeFlag,
								members: members,
								name: target.targetName,
								communityScope: dataScope?.communityScope || []
							}
						);
					}
				});
			}
		});
	};

	listPrivilegeRole = () => {
		const data = { ...this.basicInfo };
		return callApi({
			api: api.listPrivilegeRole,
			data: {
			  ...data,
				includeOperationFlag: 1
			},
			success: (res) => {
				this.setState({
					roleList: res.roles || [],
				});
			}
		});
	};

	//校验权限组名称是否可用
	checkDataGroupName = (groupData) => {
		const { labelGroupId } = this.state;
		const data = { ...this.basicInfo, labelGroupId, name: groupData.name };
		callApi({
			api: api.checkDataGroupName,
			data,
			success: (res) => {
				this.updateOrcreateRoleAuthRule(groupData);
			},
			error: (err) => {
				message.error(err.errorDescription || '权限组名称不可用');
			}
		});
	};

	//创建角色授权规则
	updateOrcreateRoleAuthRule = (dataOri) => {
		const { appId, organizationId, namespaceId } = this.basicInfo;
		const { dataGroupId } = this.state;
		const { name, allCommunityScopeFlag = 1, communityScope = [], members = [] } = dataOri;
		const membersNew = members.map((el = {}) => { delete el.assignedOperations; return el; });
		const { onChange, id, labelGroupId, type } = this.props;
		let apiUrl = api.createRoleAuthRule;
		const data = {
			...this.basicInfo,
			labelGroupId,
			members: membersNew,
			name,
			dataScope: {
				scopeType: scopeType.COMMUNITY,
				allCommunityScopeFlag: allCommunityScopeFlag,
				communityScope
			}
		};
		if (type === rightGroupModalType.EDIT) {
			data.id = id;
			data.dataGroupId = dataGroupId;
			apiUrl = api.updateRoleAuthRule;
		}

		callApi({
			api: apiUrl,
			data,
		}).then(res => {
			onChange && onChange(false);
		}).catch(err => {
			message.error(err.errorDescription);
		});
	};

	addGroup = () => {
		const form = this.formRef.current;
		const { type } = this.props;
		form.validateFields()
			.then(values => {
				const noError = this.tableRef.current.validate();
				if (!noError) {
				 return false;
				}
				switch (type) {
					case rightGroupModalType.CREAT:
						this.checkDataGroupName(values);
						break;
					default:
						this.updateOrcreateRoleAuthRule(values);
				}
			});
	};

	/**项目树相关组件start */

	// 获取项目数据
	getAuthorizedCommunities = () => {
		const { organizationId } = window.$$context;
		return callApi({
			defaultError: false,
			api: api.getAuthorizedCommunities,
			data: {
				orgId: organizationId,
				assignmentSourceTypes: ['SUP_ADMIN', 'SYS_ADMIN', 'APP_ADMIN'],
			},
			success: (res) => {
				this.setState({
					projectTree: res.authorizedCommunities || [],
					allProjectDisabled: res.allCommunityFlag !== 1,
				});
			}
		});
	};

	// 修改项目范围是否是全部
	toggleAllProject = (e) => {
		this.setState({ allCommunityScopeFlag: e.target.value });
	};

	/**项目树相关组件end */

	/**选人组件确认回调 */
	confirmSelectObjects = (selects) => {
		const members = this.handleSelectObjects(selects);
		this.setState({ NewSelectModalVisible: false });
		const form = this.formRef.current;
		const data = form.getFieldValue('members') || [];
		const newData = [...data];
		newData.forEach(element => {
			for (let i = 0; i < members.length; i++) {
				if (members[i]?.target?.targetId === element?.target?.targetId) {
					members.splice(i, 1);
					break;
				}
			}
		});
		const newMembers = [].concat(newData, members);
		form.setFields([{ name: 'members', value: newMembers }]);
		form.validateFields(['members']);
		let setRoleDisable = true;
		if (newMembers.length > 0) {
			setRoleDisable = false;
		}
		this.setState({ setRoleDisable });
	};

	/**
	 * 选人以后进行数据处理
	 * @param {*} values
	 * @returns
	 */
	handleSelectObjects = (values) => {
		const selects = values.map((item) => {
			const { selectionName: targetName, sourceDataA = {} } = item;
			const { detailId, targetType, targetId2, targetId, contactToken } = sourceDataA;
			return {
				detailId,
				target: {
					targetType,
					targetId,
					targetName,
					contactToken,
					targetId2
				},
				roleId: undefined,
				roleName: undefined,
				allOperationFlag: 0,
			};
		});
		return selects;
	};

	//批量设置角色处理接口
	handleBatchRole = (values) => {
		const { roleMembers } = values;
		const data = this.formRef.current.getFieldValue('members');
		const dataNew = data.map(el => {
			roleMembers.some(item => {
				if (el.target.targetId === item) {
					el.roleId = values.roleId;
					return true;
				}
				return false;
			});
			return el;
		});
		this.formRef.current.setFields([{ name: 'members', value: dataNew }]);
		this.setState({ checkBoxModal: false, targetList: [] });
	};

	setRoleBatch = () => {
		const data = this.formRef.current.getFieldValue('members');
		const targets = data.map(el => { return { value: el.target.targetId, label: el.target.targetName }; });
		this.setState({ checkBoxModal: true, targetList: targets });
	};

	onFormValuesChange = (changedValues, allValues = {}) => {
		if (allValues?.members?.length === 0) {
			this.setState({ setRoleDisable: true });
		}
	};

	render() {
		const { setRoleDisable, projectTree, loading, targetList, roleList, allCommunityScopeFlag, allProjectDisabled, NewSelectModalVisible, dataSource, roleManModal, checkBoxModal } = this.state;
		const { type, onChange, allPrivileges, allProjectList, hiddenFilterFlag, showProjectByGroup } = this.props;
		const { target = {}, members = [], dataScope = {} } = dataSource;
		//allCommunityScopeFlag 为1 为选择左右的项目， 为0 则选择部分， 为1 时， getRoleAuthRuleDetail 不返回项目列表
		const communityScopeforDetail = dataScope.allCommunityScopeFlag === 1 ? allProjectList : filterProject(allProjectList, dataScope.communityScope) || [];

		return (
			<div className={prefixCls}>
				{
					type !== rightGroupModalType.DETAIL ? <Modal
						visible={ true }
						title={titles[type]}
						width={612}
						bodyStyle={{ height: '506px' }}
						onCancel = {() => { onChange && onChange(false); }}
						onOk = {this.addGroup}
						wrapClassName='tablemodal'
					>
						<Spin spinning = {loading}>

							<Form name="rightGroupManagement" layout='vertical' ref={this.formRef} onValuesChange={this.onFormValuesChange}>
								<Form.Item
									label="权限组名称"
									name="name"
									rules={[{ required: true, message: '请输入名称' }, { max: 16, message: '不超过16个字段' }]}
								>
									<Input maxLength={16} />
								</Form.Item>
								{
									showProjectByGroup && <Form.Item
										label='管理项目范围'
										name="allCommunityScopeFlag"
										initialValue={communityScopeFlag.allCommunitys}
										rules={[{ required: true, message: '请选择项目' }]}
									>
										<RadioGroup onChange={this.toggleAllProject} >
											<Space direction="vertical">
												<Radio value={communityScopeFlag.allCommunitys} disabled={ allProjectDisabled } >全部项目</Radio>
												<Radio value={communityScopeFlag.customCommunitys} >指定项目</Radio>
											</Space>
										</RadioGroup>
									</Form.Item>
								}
								{
									allCommunityScopeFlag === communityScopeFlag.customCommunitys ? (
										<Form.Item
											name="communityScope"
											rules={[{ required: true, message: '请选择项目' }]}
										>
											<ProjectTree projectTree={projectTree} allProjectList={allProjectList} />
										</Form.Item>
									) : null
								}
								<Form.Item
									label={<div className='tableTitle'><span>权限组成员</span><Button disabled={setRoleDisable} onClick={this.setRoleBatch}>批量设置角色</Button></div>}
									name='members'
									rules={[{ required: true, message: '请添加成员' }]}
								>
									<MembersTable ref={this.tableRef} roleList={roleList} allPrivileges={allPrivileges} setroleManModal= {() => { this.setState({ roleManModal: true }); }} />
								</Form.Item>
							</Form>
							<span className={prefixCls + '-addMemberBtn'} onClick={() => { this.setState({ NewSelectModalVisible: true }); }}> + 添加成员</span>
							<NewSelectModal
								visible={NewSelectModalVisible}
								title="选择成员"
								namespaceId={window.$$context.namespaceId}
								organizationId={window.$$context.organizationId}
								selectType="select"
								types={['person']}
								configs={{
									person: { needAllData: true },
									hiddenFilterFlag
								}}
								onOk={this.confirmSelectObjects}
								onCancel={() => { this.setState({ NewSelectModalVisible: false }); }}
								isModal={true}
							/>
							{
								roleManModal && <RoleManagement allPrivileges={allPrivileges}
						   	onChange= {() => { this.setState({ roleManModal: false }); this.listPrivilegeRole(); }} />
							}
							<SetRoleBybatch visible={checkBoxModal} targetList={targetList} onOk={(values) => { this.handleBatchRole(values); }} onCancel={() => { this.setState({ checkBoxModal: false }); }} roleList={roleList} />

						</Spin>
					</Modal> : <Modal
						visible={ true }
						title={titles[type]}
						footer={null}
						width={612}
						bodyStyle={{ height: '476px' }}
						onCancel = {() => { onChange && onChange(false); }}
					>
						<Spin spinning = {loading}>
							<div className={prefixCls + '-detail'}>
								<div> <div>权限组名称：</div><div>{target.targetName}</div></div>
								<div> <div>管理项目范围：</div><div>{communityScopeforDetail.map(el => el.projectName || '').join('、 ')}</div></div>
								<MembersTable ref={this.tableRef} value={members} type={type} allPrivileges={allPrivileges} />
							</div>
						</Spin>
					</Modal>
				}
			</div>
		);
	}
}

export default RightGroupManagement;
